import { Box, Paper, Typography } from "@mui/material"
import { useContext, useState } from "react";
import { useHistory } from "react-router-dom";
import { AppContext } from "../context";
import AlertField from "./Alert";
import { TextInput } from "./Input";
import { PrimaryButton } from "./PrimaryButton";


export const ShortIdForm = () => {
  const { lead } =  useContext<any>(AppContext);
  const history = useHistory();
  const [openAlert, setOpenAlert] = useState<boolean>(false)
  const [alertMessage, setAlertMessage] = useState<string>('')

  const handleClose = () => {
    setOpenAlert(false)
  }

  const handleSubmit = async (event: any) => {
      event.preventDefault();
      const emailCode = event.target.code.value
      console.log(emailCode)
      console.log(lead.shortId)
      if(emailCode === '') {
        setAlertMessage('Por favor, informe o código de segurança!')
        setOpenAlert(true)
      } else if (emailCode !== lead.shortId) {
        setAlertMessage('Código inválido!')
        setOpenAlert(true)
      } else {
        history.push('/pagamento')
      }
    }
    return (
        <Box
    sx={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      backgroundColor: "background.default",
      }}
    >
      <Paper
        variant="outlined" 
        elevation={2}
        sx={{
        backgroundColor: "background.default",
        px: 15,
        py: 5
        }} >
          <AlertField message={alertMessage} status={openAlert} handle={handleClose} />
         <Typography
           sx={{color: 'primary.main', fontSize: '1.2rem', mb: 2}}>
          Por favor insira o código de segurança:
          </Typography>
      <form onSubmit={handleSubmit}>
        <Box sx={{ display: "flex", alignItems: "flex-end" }}>
          <TextInput
           id="code" 
           label="Código de segurança"/>
        </Box>
        <Box sx={{ display: "flex", alignItems: "flex-end", mt: 2 }}>
          <PrimaryButton name="Prosseguir" />
        </Box>
      </form>
      </Paper>
    </Box>
    )
}